import NetworkingOperations from "../index";

const PaymentInit = (data) => {
	const url = process.env.REACT_APP_PAYMENT_INIT;

	return NetworkingOperations.post({ url, data }).then((res) => res);
};

export default PaymentInit;
